import { useDispatch, useSelector } from 'react-redux'
import { selectPagination } from '../DashboardV2Selectors'
import { setCurrentPage, setPage } from '../DashboardV2Slice'

const useContractsPagination = () => {
  const dispatch = useDispatch()
  const pagination = useSelector(selectPagination)

  const goToNextPage = () => {
    if (pagination.nextCursor) {
      dispatch(setCurrentPage(pagination.currentPage + 1))
      dispatch(setPage(pagination.nextCursor))
    }
  }

  const goToPreviousPage = () => {
    if (pagination.prevCursor && pagination.currentPage > 1) {
      dispatch(setCurrentPage(pagination.currentPage - 1))
      dispatch(setPage(pagination.prevCursor))
    }
  }

  return {
    pagination,
    goToNextPage,
    goToPreviousPage,
    hasNext: !!pagination.nextCursor,
    hasPrevious: !!pagination.prevCursor && pagination.currentPage > 1,
  }
}

export default useContractsPagination
